import * as types from './Types.js';

import {
  downloadArquivoBlob,
  getExtension,
  getUrlArquivoBlob
} from './ArquivoUtils';

import { Map } from 'immutable';
import configuration from 'portaltransparencia-common/config/Config.js';

const criarAcaoDownload = (id, url, apenasUrl) => {
  if (url && !apenasUrl) {
    window.open(url, '_blank');
  }

  return {
    type: types.ARQUIVO_DOWNLOAD,
    payload: id,
    url
  };
};

const getUrlFiles = id =>
  id ? `${configuration.apiURL}/api/files/arquivo/${id}` : undefined;

export function downloadArquivo(item, apenasUrl) {
  let id = item;

  if (item instanceof Map) {
    id = item.get('idArquivo');

    if (!id) {
      let pathArquivo = item.get('pathArquivo');

      if (getExtension(pathArquivo) === 'pdf') {
        pathArquivo = '';
      }

      if (apenasUrl) {
        return criarAcaoDownload(
          id,
          getUrlArquivoBlob(item.get('arquivo'), pathArquivo),
          apenasUrl
        );
      }

      downloadArquivoBlob(item.get('arquivo'), pathArquivo);

      return criarAcaoDownload(id, undefined, apenasUrl);
    }
  }

  return criarAcaoDownload(id, getUrlFiles(id), apenasUrl);
}

export function downloadArquivoEscalas(item, apenasUrl) {
  let id = item;

  if (item instanceof Map) {
    id = item.get('id');
  }

  return criarAcaoDownload(
    id,
    `${configuration.apiURL}/api/escalas-profissionais/${id}`,
    apenasUrl
  );
}

export function downloadArquivoAtas(item, apenasUrl) {
  let id = item;

  if (item instanceof Map) {
    id = item.get('id');
  }

  return criarAcaoDownload(
    id,
    `${configuration.apiURL}/api/conselhos/arquivo/${id}`,
    apenasUrl
  );
}

export function downloadArquivoDocumentos(item, apenasUrl) {
  let id = item;

  if (item instanceof Map) {
    id = item.get('id');
  }

  return criarAcaoDownload(
    id,
    `${configuration.apiURL}/api/documentos-saude/${id}`,
    apenasUrl
  );
}

export function downloadArquivoConvenio(item, apenasUrl) {
  let id = item;
  let url;

  if (item instanceof Map) {
    if (item.get('link')) {
      url = item.get('link');
    } else {
      id = item.get('idArquivo');
      url = `${configuration.apiURL}/api/convenios/convenio-anexo/download/${id}`;
    }
  }

  return criarAcaoDownload(id, url, apenasUrl);
}

export function downloadArquivoAudienciaPublica(item, apenasUrl) {
  let id = item;

  if (item instanceof Map) {
    id = item.get('idArquivo');
  }

  return criarAcaoDownload(
    id,
    `${configuration.apiURL}/api/audiencias-publicas/anexo/download/${id}`,
    apenasUrl
  );
}
